export default {
  namespaced: true,
  risk: {
    title: "Evaluación de Riesgo ",
    template: {
      title: "Plantilla | Plantillas formulario",
      name: "Nombre",
      question: "Pregunta | Preguntas",
      add_new_field: "Agregar Un Nuevo Campo",
      type_response: "Tipo de Respuesta",
      field_name: "Nombre del Campo",
      field_types: "Tipos de Campo",
      field_type_config: "Configuración del Tipo de Campo",
      options: "Opciones",
      option_name: "Nombre de la opción",
      add_option: "Agregar una opción",
      added_options: "Opciones agregadas",
      add_section: "Agregar sección",
      new_section: "Nueva sección",
      section_name: "Nombre de la sección",
      no_section: "Sin sección",
      add_field_here: "Agregar pregunta aquí",
      drop_or_add_here: "Arrastra o agrega aquí",
      confirm_delete_section:
        "¿Eliminar la sección? Sus preguntas pasarán a 'Sin sección'.",
      confirm_delete_field: "¿Eliminar esta pregunta?",
      visibility: "Visibilidad",
      condition: "Condicionar",
      previous_question: "Pregunta (previa)...",
      match_any: "Coincida alguna",
      match_all: "Coincidan todas",
      select_one_or_more: "Selecciona una o más opciones (Ctrl/Cmd + click).",
      select_option: "Selecciona...",
      clear: "Limpiar",
      no_conditions: "Sin condiciones: este campo siempre es visible.",
      error_invalid_conditions: "La pregunta referenciada ya no existe en esta sección.",
      error_invalid_order: "La pregunta referenciada debe ser anterior.",
      error_missing_value: "Selecciona al menos una opción para la condición.",
      placeholder_value: "Valor del Placeholder",
      placeholder_hint: "Ej: @FECHA, @HORA, @ID",
      placeholder_available: "Disponibles",
      placeholder_separator_hint: "Puedes agregar múltiples valores separados por comas o guiones",
      add_placeholder: "Agregar Placeholder",
      added_placeholders: "Placeholders Agregados",
      placeholder_already_exists: "Este placeholder ya existe",

      // Placeholder values
      placeholder_date: "@FECHA",
      placeholder_time: "@HORA",
      placeholder_datetime: "@FECHA_HORA",
      placeholder_reference: "@REFERENCIA",
      placeholder_id: "@ID",
    },
    evaluation: {
      title: "Evaluación | Evaluaciones",
    },
    form_validations: {
      name: "El nombre es obligatorio",
      type: "El tipo es obligatorio",
    },
    form: {
      title: "formulario de riesgo",
    },
    required: "Requerido",
    risk_percentage: "Porcentaje de riesgo (%)",
    close: "Cerrar",
    Apply: "Aplicar",
    comment: "Comentario",
    file: "Archivos",
    select_form: "Selecciona los formularios de asignación de riesgos",
    select_form_place_holder: "Seleccione un formulario",
    selected_form: "Formulario seleccionado",
    answer_form: "Responder formulario",
    new_evaluation: "Nueva Evaluación",
    risk_evaluations_title: "Evaluación de riesgos",
    confirm_delete: "¿Estás seguro de eliminar esta evaluación?",
    no_evaluations: "No se encontraron evaluaciones",
    download: "Descargar evaluación",
    evaluation_deleted: "Evaluación eliminada",
    filters: {
      units: "Unidades",
      users: "Usuarios",
      status: "Estado",
      date_range: "Rango de Fechas",
      start_date: "Fecha de Inicio",
      end_date: "Fecha de Fin",
      status_form: "Estado de formulario",
    },
    operational_procedures: "Procedimientos Operativos",
    reference_number: "Número de Referencia",
    title_notification: "Evaluación de riesgo",
    status_notification: "Estado",
    remove_notification: "Eliminar",
    status_schedule: "Programado",
    status_in_progress: "En Progreso",
    status_in_review: "En Revisión",
    status_assigned: "Asignado",
    status_in_review: "En Revisión",
    status_approved_cancelled: "Aprobado/Cancelado",
    status_rejected: "Rechazado",
    status_approved: "Aprobado",
    status_canceled: "Cancelado",
    status_reassigned: "Reasignado",
    no_completed_evaluations: "No se encontraron evaluaciones completadas",
    last_completed_result: "Último resultado completado",
    add_comment: "Agregar comentario",
    review_comments_title: "Comentarios de revisión",
    user: "Usuario",
  },
  confirm_cancel: "¿Estás seguro de que deseas cancelar esta evaluación?",
  canceled: "Evaluación cancelada",
};
